var map = {
	"./a-thoughtful-career-journey-lessons-from-my-job-transitions.md": [
		2117,
		2117
	],
	"./act-now-or-stay-stuck.md": [
		4280,
		4280
	],
	"./ai-is-moving-from-automation-to-autonomy-what-it-means-to-developers.md": [
		5490,
		5490
	],
	"./appreciate-what-you-have-because-it-might-not-be-there-tomorrow.md": [
		1178,
		1178
	],
	"./art-of-doing-nothing.md": [
		1605,
		1605
	],
	"./as-a-developer-language-still-feels-like-magic.md": [
		8039,
		8039
	],
	"./being-subjective-in-workplace.md": [
		6953,
		6953
	],
	"./chasing-attention.md": [
		578,
		578
	],
	"./communities-with-defeated-purpose.md": [
		6638,
		6638
	],
	"./developer-focused-design-choices.md": [
		3880,
		3880
	],
	"./empty-your-mind.md": [
		3650,
		3650
	],
	"./end-day-strong-note.md": [
		3645,
		3645
	],
	"./even-the-brightest-minds-bow-to-uncertainty.md": [
		6367,
		3986
	],
	"./financial-insights-at-35.md": [
		4780,
		4780
	],
	"./i-have-studied-codex-for-a-month-here-is-what-i-found-by-creating-a-complex-animation-framework.md": [
		8421,
		8421
	],
	"./life-changing-books-for-power-purpose-and-growth.md": [
		6362,
		6362
	],
	"./life-s-beauty.md": [
		9617,
		9617
	],
	"./making-sense-of-neural-networks.md": [
		3052,
		3052
	],
	"./no-one-is-coming-to-save-you-and-thats-a-good-thing.md": [
		803,
		803
	],
	"./observer-and-anti-observer-rethinking-the-puzzle-of-consciousness.md": [
		789,
		789
	],
	"./observer-and-the-observed-are-the-same.md": [
		9589,
		9589
	],
	"./pushing-coding-agents-to-the-edge-lessons-from-burning-304m-tokens.md": [
		5735,
		5735
	],
	"./pyramid-schemes.md": [
		9317,
		9317
	],
	"./real-intelligence-is-about-organizing-information.md": [
		2319,
		2319
	],
	"./relationships-at-work.md": [
		2171,
		2171
	],
	"./safety-is-a-snapshot-security-is-a-system.md": [
		1841,
		4222
	],
	"./small-lie-with-big-impact.md": [
		9249,
		9249
	],
	"./small-talk-on-networking-and-understanding-oneself.md": [
		9449,
		9449
	],
	"./stay-away-from-competition.md": [
		1029,
		1029
	],
	"./the-aha-moment.md": [
		3427,
		3427
	],
	"./the-fear-takes-it-all.md": [
		2971,
		2971
	],
	"./the-fractal-of-understanding-why-knowing-feels-infinite.md": [
		7926,
		7926
	],
	"./the-free-agent-woman-mastering-growth-mentorship-and-power.md": [
		1850,
		1850
	],
	"./the-harsh-truth-about-work-what-every-new-engineer-must-know.md": [
		2546,
		2546
	],
	"./the-hidden-costs-of-homeownership-why-buying-a-house-isnt-always-the-right-choice.md": [
		219,
		219
	],
	"./the-hidden-danger-of-living-by-rules.md": [
		3824,
		3824
	],
	"./the-inevitable-cycle-growth-stagnation-and-reinvention-in-a-tech-career.md": [
		6015,
		6015
	],
	"./the-journey-to-self-understanding-and-leadership.md": [
		7924,
		7924
	],
	"./the-lies-we-tell-ourselves-unattainable-fantasies-that-keep-us-trapped.md": [
		2015,
		2015
	],
	"./the-moment-we-realize-we-were-not-special.md": [
		5991,
		5991
	],
	"./the-power-of-deep-conversations-discovering-the-hidden-answers-within.md": [
		3692,
		3692
	],
	"./the-power-of-passive-learning.md": [
		88,
		88
	],
	"./the-rise-and-fall-of-trust-how-workplace-culture-shapes-success-or-failure.md": [
		7519,
		7519
	],
	"./the-rise-of-project-level-prompts-why-the-future-needs-more-prompt-engineers.md": [
		6611,
		6611
	],
	"./the-unspoken-reality-of-senior-professionals-in-a-changing-workplace.md": [
		1791,
		1791
	],
	"./thinking-tools-understand-daily-events.md": [
		761,
		761
	],
	"./trapped-in-the-matrix-the-myth-of-freedom.md": [
		3128,
		3128
	],
	"./unit-tests-for-life.md": [
		2817,
		2817
	],
	"./when-time-speaks-will-you-listen.md": [
		1039,
		1039
	],
	"./why-can-we-only-remember-the-past-and-not-the-future.md": [
		2448,
		2448
	],
	"./why-do-we-want-to-believe-anything.md": [
		330,
		330
	],
	"./why-i-stopped-chasing-loud-goals-and-started-listening-to-myself.md": [
		8465,
		8465
	],
	"./why-we-cling-to-identities-and-how-curiosity-offers-a-way-out.md": [
		7338,
		7338
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7511;
module.exports = webpackAsyncContext;